 /**
 * v-hasPermi 操作权限处理
 * Copyright (c) 2025 sfuture , All Rights Reserved
 */
 
import useUserStore from '@/store/modules/user'

const originalDisplay = new WeakMap()

function updatePermissionVisibility(el, binding) {
  const { value } = binding
  if (!value || !(value instanceof Array) || value.length === 0) {
    throw new Error(`请设置操作权限标签值`)
  }

  const permissions = useUserStore().permissions
  const hasPermissions = permissions.some(permission => {
    return permission === '*:*:*' || value.includes(permission)
  })

  el.style.display = hasPermissions ? originalDisplay.get(el) : 'none'
}

export default {
  mounted(el, binding) {
    originalDisplay.set(el, el.style.display)
    updatePermissionVisibility(el, binding)
  },
  updated(el, binding) {
    updatePermissionVisibility(el, binding)
  },
  beforeUnmount(el) {
    originalDisplay.delete(el)
  }
}
